import { render, staticRenderFns } from "./SectionLabel.vue?vue&type=template&id=3f4206a6&scoped=true&"
import script from "./SectionLabel.vue?vue&type=script&lang=ts&"
export * from "./SectionLabel.vue?vue&type=script&lang=ts&"
import style0 from "./SectionLabel.vue?vue&type=style&index=0&id=3f4206a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4206a6",
  null
  
)

export default component.exports